import { EntityType } from 'api'
import { createAllEntitiesHook, createEntityGetterHook, createEntityHook } from './common'
import { createReferenceDataEntityHook } from './referenceData'

export const useProductSector = createEntityHook(EntityType.PRODUCT_SECTOR)
export const useAllProductSectors = createAllEntitiesHook(EntityType.PRODUCT_SECTOR)
export const useProductSectorGetter = createEntityGetterHook(EntityType.PRODUCT_SECTOR)
export const useProductSectorReferenceData = createReferenceDataEntityHook(EntityType.PRODUCT_SECTOR)
